// extracted by mini-css-extract-plugin
export var consent = "HubspotForm-module--consent--AvsYq";
export var consentContainer = "HubspotForm-module--consentContainer--krgzj";
export var consentField = "HubspotForm-module--consentField---eC2Z";
export var errorMsg = "HubspotForm-module--errorMsg--sHw2h";
export var errorStyles = "HubspotForm-module--errorStyles--i+B0s";
export var page404Title = "HubspotForm-module--page404-title--ksCoz";
export var recaptcha = "HubspotForm-module--recaptcha--7ek6i";